"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = withFormControl;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _compose = _interopRequireDefault(require("lodash/fp/compose"));
var _size = _interopRequireDefault(require("lodash/fp/size"));
var _isNil = _interopRequireDefault(require("lodash/fp/isNil"));
var _isUndefined = _interopRequireDefault(require("lodash/fp/isUndefined"));
var _isFunction = _interopRequireDefault(require("lodash/fp/isFunction"));
var _FormControlContext = require("./FormControlContext");
var _excluded = ["defaultValue", "value", "onChange", "onFocus", "onBlur"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
// eslint-disable-next-line @typescript-eslint/comma-dangle
var isControlled = function isControlled(_ref) {
  var value = _ref.value,
    onChange = _ref.onChange;
  return !(0, _isUndefined["default"])(value) && (0, _isFunction["default"])(onChange);
};
var getTextCount = function getTextCount(value) {
  return (0, _isNil["default"])(value) ? 0 : (0, _size["default"])(value.toString());
};
function withFormControl(Component) {
  var FormControlHOC = function FormControlHOC(_ref2, ref) {
    var _ref2$defaultValue = _ref2.defaultValue,
      defaultValue = _ref2$defaultValue === void 0 ? '' : _ref2$defaultValue,
      value = _ref2.value,
      onChange = _ref2.onChange,
      onFocus = _ref2.onFocus,
      onBlur = _ref2.onBlur,
      rest = (0, _objectWithoutProperties2["default"])(_ref2, _excluded);
    var isControlledUsecase = isControlled({
      value: value,
      onChange: onChange
    });
    var _useState = (0, _react.useState)(defaultValue),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      internalValue = _useState2[0],
      setInternalValue = _useState2[1];
    var _useState3 = (0, _react.useState)((0, _size["default"])((defaultValue || value || '').toString())),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      textCount = _useState4[0],
      setTextCount = _useState4[1];
    var _useState5 = (0, _react.useState)(false),
      _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
      isActive = _useState6[0],
      setIsActive = _useState6[1];
    var handleFocus = (0, _react.useCallback)(function (e) {
      setIsActive(true);
      onFocus === null || onFocus === void 0 || onFocus(e);
    }, [onFocus]);
    var handleBlur = (0, _react.useCallback)(function (e) {
      setIsActive(false);
      onBlur === null || onBlur === void 0 || onBlur(e);
    }, [onBlur]);
    var onUncontrolledChange = (0, _react.useCallback)(function (e) {
      setTextCount((0, _size["default"])(e.target.value));
      setInternalValue(e.target.value);
    }, [setTextCount]);
    (0, _react.useEffect)(function () {
      if (isControlledUsecase) {
        setTextCount(getTextCount(value));
      }
    }, [value, isControlledUsecase]);
    var inputProps = isControlledUsecase ? {
      value: value,
      onChange: onChange
    } : {
      value: internalValue,
      onChange: onUncontrolledChange
    };
    return /*#__PURE__*/_react["default"].createElement(_FormControlContext.FormControlProvider, {
      value: {
        textCount: textCount,
        isActive: isActive
      }
    },
    /*#__PURE__*/
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    _react["default"].createElement(Component, (0, _extends2["default"])({
      ref: ref,
      onFocus: handleFocus,
      onBlur: handleBlur
    }, inputProps, rest)));
  };
  var Composed = (0, _compose["default"])(_react.memo, _react["default"].forwardRef)(FormControlHOC);
  return Composed;
}